import {
  MonthlyTrendingComparativeViewValues,
  type MonthlyTrendingComparativeView,
  type ReportLineType,
} from '@erp/shared-types';
import { useMonthlyTrending } from '@/api/rebates/useReports';

function alternateComparativeView(
  view: MonthlyTrendingComparativeView | undefined,
): MonthlyTrendingComparativeView {
  return view === MonthlyTrendingComparativeViewValues.REPORTED
    ? MonthlyTrendingComparativeViewValues.CURRENT
    : MonthlyTrendingComparativeViewValues.REPORTED;
}

export function useMonthlyTrendingWithPrefetch(params: {
  year: number;
  divisionIds?: string[];
  priorYearLineType?: ReportLineType;
  throughMonth?: number;
  comparativeView?: MonthlyTrendingComparativeView;
  enabled?: boolean;
}) {
  const primary = useMonthlyTrending(params);
  useMonthlyTrending({
    ...params,
    comparativeView: alternateComparativeView(params.comparativeView),
    enabled: primary.isSuccess,
  });
  return primary;
}
